// src/api/client.js
import axios from 'axios';
import { refreshAuthToken } from './auth';

// Create base API URL from environment or default to localhost
const API_URL = process.env.REACT_APP_API_URL || '/api';

// Create axios instance with common configuration
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Debug logging for batch/submit endpoint
    if (config.url && config.url.includes('batch/submit')) {
      console.log('=== BATCH SUBMIT REQUEST DEBUG ===');
      console.log('URL:', config.url);
      console.log('Method:', config.method);
      console.log('Headers:', config.headers);
      console.log('Data:', config.data);
      console.log('Data type:', typeof config.data);
      console.log('================================');
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling common errors
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If error is 401 Unauthorized and not already retrying
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // Attempt to refresh the token
        // Note: Implement refreshAuthToken in auth.js
        // const newToken = await refreshAuthToken();
        // localStorage.setItem('token', newToken);
        // originalRequest.headers.Authorization = `Bearer ${newToken}`;
        // return apiClient(originalRequest);
        
        // For now, just redirect to login
        window.location.href = '/login';
        return Promise.reject(error);
      } catch (refreshError) {
        // If refresh fails, redirect to login
        localStorage.removeItem('token');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    
    // Handle other common errors
    if (error.response?.status === 403) {
      console.error('Permission denied');
      // Handle forbidden error
    }
    
    if (error.response?.status === 500) {
      console.error('Server error', error.response.data);
      // Handle server error
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;